


import React, { useEffect, useState } from "react";


//  Icons
import { MdOutlineEmail } from "react-icons/md";
import { SlLocationPin } from "react-icons/sl";
import { BsTelephoneInbound } from "react-icons/bs";
import { MdOutlineAddIcCall } from "react-icons/md";
import { FaMobileAlt } from "react-icons/fa";
//images

import imageCont from '../../assets/images/contactimage.png';


//Email js
import { useRef } from 'react';
import emailjs from '@emailjs/browser';
import Metatag from "../Metatag/Metatag";


const Contacthome = () => {
  useEffect(() => {
    // Scroll to the top when the page loads
    window.scrollTo(0, 0);
  }, []);
  
  //Email js
  const form = useRef();
   const [errors, setErrors] = useState({});
   const validateForm = () => {
    const formElements = form.current.elements;
    const emailInput = form.current.querySelector('input[name="user_email"]');
    const nameInput = form.current.querySelector('input[name="user_name"]');
    const companyNameInput = form.current.querySelector('input[name="user_companyname"]');
    const mobileNumberInput = form.current.querySelector('input[name="user_number"]');
    const messageInput = form.current.querySelector('textarea[name="message"]');

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let newErrors = {};

    // Check if any required field is empty
    if (!nameInput.value) newErrors.name = 'Name is required.';
    if (!emailInput.value) newErrors.email = 'Email is required.';
    else if (!emailRegex.test(emailInput.value)) newErrors.email = 'Please enter a valid email address.';
    if (!companyNameInput.value) newErrors.companyName = 'Company Name is required.';
    if (!mobileNumberInput.value) newErrors.mobileNumber = 'Mobile Number is required.';
    if (!messageInput.value) newErrors.message = 'Message is required.';

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const sendEmail = (e) => {
    e.preventDefault();

    if (!validateForm()) return;
    

    emailjs
    .sendForm('service_8pysjhc', 'template_277588x', form.current, {
      publicKey: 'MP5e9FrgJA3B8tlWz',
    })
      .then(
        () => {
          alert('Your message has been successfully sent!');
          console.log('SUCCESS!');
          form.current.reset(); // Reset the form fields after successful submission
          setErrors({}); // Clear errors after successful submission
        },
        (error) => {
          console.log('FAILED...', error.text);
        }
      );
  };
 
  return (
    <>
    {/* <Metatag title="" description="Have questions or need assistance? Contact Megavolt Technical Services today. Reach out via phone, email,or our online form for prompt support and solutjans." link="contactus"/> */}
    <div className=" " style={{backgroundImage:`url()`}}>
      <div className=" ">
        <div className=" text-center items-center  mb-3 mt-5">
          <h1 className=" text-[34px] font-semibold  text-[black]">Contact <span className=" text-[#ffb732] text-[38px]">US</span></h1>
        </div>
        <div className=" hidden">
          
          <div className="rounded-xl lg:w-[60%] w-auto border-t-[2px] border-[#cbcbcb]  lg:p-4 p-2" style={{ boxShadow: '0px 2px 25px #7c78754f' }}>
            {/* <div className="md:flex items-center justify-between py-3"> 
              <div className="hidden md:block">
                <div className="flex items-center">
                  <div className=" text-[23px]  rounded-3xl p-2  bg-black  text-[#ffb732]" >
                    <SlLocationPin />
                  </div>
                  <h3 className=" text-[#ffb732] text-2xl font-semibold pl-2">Location:</h3>
                </div>
              </div>
              <div>
                <div className=" flex items-center">
                  <div className=" text-[23px]  rounded-2xl p-2  bg-black  text-[#ffb732]" >
                    <MdOutlineEmail />
                  </div>
                  <div className="flex items-center ">
                    <h3 className=" text-[#ffb732] text-2xl font-semibold pl-2 mr-2">Email:</h3>
                    <a href="mailto:info@dewaapproval.ae" className="text-xl font-bold">info@dewaapproval.ae</a>
                  </div>
                 
                </div>
              
              </div>
            </div> */}
            {/* <div className="   mt-3">
          
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3608.2065739154837!2d55.3310044!3d25.263635500000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5d000ad9b423%3A0xdb1e4689a8ba098f!2sMegavolt%20Technical%20Services%20Co.%20LLC!5e0!3m2!1sen!2sin!4v1727601258840!5m2!1sen!2sin"
                width="100%"
                height="400"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div> */}

          </div>

          {/* seconddiv */}
          <div className="border-t-[2px]  rounded-xl border-[#cbcbcb] border-b-[1px] sm:p-4 lg:w-[40%] w-auto  p-2" style={{ boxShadow: '2px 2px 25px #7c78754f' }}>
            {/* <div className=" text-center">
              
              <h1 className="uppercase text-3xl font-bold">our entities</h1>
            </div>
            <div className=" pl-5 pt-4 leading-8 text-center pb-5">
              <h1 className=" text-[18px]  text-[#ffb732] font-bold"> Megavolt Technical Services LLC</h1>
              <div className="text-[#090a0e] text-[17px] pt-1">
                <p className="text-[#090a0e]">12,22A Street, </p>
                <p>Al Khabaisi-Dubai,</p> <p>United Arab Emirates.</p>
              </div>

            </div> */}
              {/* <div className=" flex">
                <div>
              <div className=" flex items-center pl-2 pt-8">
                <div className=" text-[23px]  rounded-2xl p-2 bg-black  text-[#ffb732]" >
                  <BsTelephoneInbound />
                </div>
                <h3 className=" text-[#ffb732] text-xl font-semibold pl-2">Telephone :</h3>
              </div>
              <div className=" pl-[64px] text-[16px] text-[#090a0e] hover:text-[#576eae] hover:cursor-pointer  w-max pt-[6px]">
              <p> <a href="tel:+971 55 481 2897"> +971 55 481 2897</a></p>
              </div>
              <div className=" flex items-center pl-2 pt-2">
                <div className=" text-[23px]  rounded-xl p-2 bg-black  text-[#ffb732]" >
                  <FaMobileAlt />
                </div>
                <h3 className=" text-[#ffb732] text-2xl font-semibold pl-2">Mobile :</h3>
              </div>
              <div className=" pl-[64px] text-[16px] text-[#090a0e] hover:text-[#576eae]  w-max hover:cursor-pointer pt-[6px]">
              <p> <a href="tel:+971 55 481 2897"> +971 55 481 2897</a></p>
              </div>
              <div className=" flex items-center pl-2 pt-2">
                <div className=" text-[23px]  rounded-xl p-2 bg-black  text-[#ffb732]" >
                  <MdOutlineAddIcCall />
                </div>
                <h3 className=" text-[#ffb732] text-2xl font-semibold pl-2">Fax :</h3>  
              </div>
              <div className=" pl-[64px] text-[16px] text-[#090a0e] hover:text-[#576eae]  w-max hover:cursor-pointer pt-[6px]">
              <p> <a href="tel:+971 55 481 2897"> +971 55 481 2897</a></p>
              </div>
              </div>
              <div className=" pl-5">
                <img src={imageCont} alt="image1" />
              </div>
            </div> */}
          </div>
        </div>
        <div className="" style={{backgroundImage:`url($)`}}>
        <div className="p-3 xl:w-[50%] sm:w-[75%]  mx-auto mt-8 mb-10">
          
           <form ref={form} onSubmit={sendEmail}>
      <div className="bg-white border-[#cbcbcb] border-b-[1px] p-4 rounded-md" style={{ boxShadow: '2px 2px 25px #7c78754f' }}>
        <div className="sm:flex sm:flex-row mb-4">
          <div className="sm:w-1/2 sm:pr-3">
            <label className="text-lg font-semibold text-[black]">Name</label>
            <input
              type="text"
              name="user_name"
              className="w-full border rounded-md text-[#576eae] font-normal mt-1 p-[6px] focus:outline-none border-[#fa962bb0]"
              style={{ background: 'none' }}
            />
            {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
          </div>
          <div className="sm:w-1/2 sm:pl-3">
            <label className="text-lg font-semibold text-[black]">Email</label>
            <input
              type="email"
              name="user_email"
              className="w-full border rounded-md text-[#090a0e] mt-1 p-[6px] focus:outline-none border-[#fa962bb0]"
              style={{ background: 'none' }}
            />
            {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
          </div>
        </div>
        <div className="mb-4">
          <label className="text-lg font-semibold text-[black]">Company Name</label>
          <input
            type="text"
            name="user_companyname"
            className="w-full border mt-1 p-1 rounded-md text-[#090a0e] focus:outline-none border-[#fa962bb0]"
            style={{ background: 'none' }}
          />
          {errors.companyName && <p className="text-red-500 text-sm">{errors.companyName}</p>}
        </div>
        <div className="sm:flex sm:flex-row mb-4">
          <div className="sm:w-1/2 sm:pr-3">
            <label className="text-lg font-semibold text-[black]">Mobile Number</label>
            <input
              type="number"
              name="user_number"
              className="w-full border mt-1 p-1 rounded-md text-[#090a0e] focus:outline-none border-[#fa962bb0]"
              style={{ background: 'none' }}
            />
            {errors.mobileNumber && <p className="text-red-500 text-sm">{errors.mobileNumber}</p>}
          </div>
          <div className="sm:w-1/2 sm:pl-3">
            <label className="text-lg font-semibold text-[black]">Phone Number</label>
            <input
              type="number"
              name="user_mobilenumber"
              className="w-full border mt-1 p-[6px] rounded-md text-[#090a0e] focus:outline-none border-[#fa962bb0]"
              style={{ background: 'none' }}
            />
          </div>
        </div>
        <div className="mb-4">
          <label className="text-lg font-semibold text-[black]">Message</label>
          <textarea
            name="message"
            className="w-full border mt-1 p-1 rounded-md text-[#090a0e] focus:outline-none border-[#fa962bb0]"
            style={{ background: 'none' }}
          />
          {errors.message && <p className="text-red-500 text-sm">{errors.message}</p>}
        </div>
        <div className="text-center">
          <input
            type="submit"
            value="Send"
            className="px-5 bg-[#fb9c2c] py-2 text-white rounded-md cursor-pointer"
          />
        </div>
      </div>
    </form>
          

        </div>
        </div>
      </div>
     
      </div>
    </>
  );
};

export default Contacthome;
